<template>
  <div class="dashboard-block">
    <h2 v-if="(($userIsAdmin || $userIsIntern || $userIsManager) && userIsTalent)">{{ user.first_name }}'s Bookings</h2>
    <h2 v-else-if="$userIsTalent">My Bookings</h2>

    <div class="panel panel-grey m-b-xl">
      <div class="panel-body">
        <ul class="nav nav-tabs" role="tablist">
          <li v-if="$vlastMode && $offersModuleEnabled" :class="{ 'active': status === 'scheduled' }">
            <router-link :to="{ params: { status: 'offer' }, query: $route.query }">Offers</router-link>
          </li>
          <li :class="{ 'active': status === 'event' }">
            <router-link :to="{ params: { status: 'event' }, query: $route.query }">Booked Events</router-link>
          </li>
          <li :class="{ 'active': status === 'campaign' }">
            <router-link :to="{ params: { status: 'campaign' }, query: $route.query }">Booked Campaigns</router-link>
          </li>
          <li :class="{ 'active': status === 'completed-event' }">
            <router-link :to="{ params: { status: 'completed-event' }, query: $route.query }">Completed Events</router-link>
          </li>
          <li :class="{ 'active': status === 'completed-campaign' }">
            <router-link :to="{ params: { status: 'completed-campaign' }, query: $route.query }">Completed Campaigns</router-link>
          </li>
          <li :class="{ 'active': status === 'archived' }">
            <router-link :to="{ params: { status: 'archived' }, query: $route.query }">Cancelled</router-link>
          </li>
        </ul>

        <pickstar-loading v-if="fetchingBookings" class="m-t-lg"/>

        <template v-else>
          <no-results v-if="haveNoBookings">
            <div>There are no bookings.</div>

            <button v-if="haveAppliedFilters" @click="handleResetFiltersCallback" class="btn btn-default btn-sm m-t-sm">Reset Filters</button>
          </no-results>

          <ul class="item-detail item-detail-price list-links">
            <profile-talent-booking-list-item
              v-for="booking in bookings"
              :key="booking.id"
              :booking="booking"/>
          </ul>

          <lazy-loading
            class="text-center"
            :loading="loading"
            :reached-bottom="handleGetNextTalentBookingsCallback"
            ref="lazyLoading">
            <pickstar-loading slot="loading"/>
            <span slot="finished"></span>
          </lazy-loading>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { helpers } from 'mixins/users'
import { mapActions, mapState, mapGetters } from 'vuex'
import { appliesFilters, handleServerErrors, fetchResourceScope } from 'mixins'
import LazyLoading from 'codium-lazy-loading'
import ProfileTalentBookingListItem from './ProfileTalentBookingListItem'

export default {
  mixins: [helpers, fetchResourceScope, appliesFilters, handleServerErrors],

  props: {
    talent: {
      required: true
    }
  },

  components: {
    ProfileTalentBookingListItem,
    LazyLoading
  },

  data () {
    return {
      fetchingBookings: false,
      status: 'event'
    }
  },

  computed: {
    ...mapState('booking', ['bookings', 'pagination', 'filters']),
    ...mapGetters('booking', ['initialFiltersState']),
    ...mapState('app', ['loading']),
    ...mapState('user', ['user']),

    haveNoBookings () {
      return this.bookings.length === 0
    }
  },

  watch: {
    '$route': {
      handler () {
        this.handleGetBookingsCallback()
      }
    }
  },

  created () {
    this.handleGetBookingsCallback()
  },

  methods: {
    ...mapActions('booking', ['getTalentBookings', 'getNextTalentBookings', 'setFilter', 'resetFilters']),

    handleGetBookingsCallback () {
      // set the sorting according to the status
      if (this.$route.params.status === 'event' || this.$route.params.status === 'campaign' || this.$route.params.status === 'archived') {
        this.setFilter({ filter: 'sort', value: 'scheduled_date' })
        this.setFilter({ filter: 'order', value: 'asc' })
      }

      if (this.$route.params.status === 'completed-campaign' || this.$route.params.status === 'completed-event') {
        this.setFilter({ filter: 'sort', value: 'completed_date' })
        this.setFilter({ filter: 'order', value: 'desc' })
      }

      this.status = this.$route.params.status

      this.fetchingBookings = true

      let talentId = null
      if (!this.talent.id) {
        if (this.$userIsTalent) {
          talentId = this.$user.id
        }
      } else {
        talentId = this.talent.id
      }

      return this.getTalentBookings({ id: talentId, params: this.queryParams })
        .catch(this.handleServerErrorsCallback)
        .finally(() => {
          this.fetchingBookings = false

          this.$nextTick(() => {
            if (!this.$refs.lazyLoading) {
              return
            }

            this.$refs.lazyLoading.$emit('reset')
          })
        })
    },

    handleGetNextTalentBookingsCallback () {
      return this.getNextTalentBookings({ id: this.talent.id, params: this.queryParams })
        .catch(this.handleServerErrorsCallback)
    }
  }
}
</script>
